import React, { useEffect, useState } from 'react'
import { Row, Col, Form, Card, Button, Divider, Checkbox, Select, Input } from 'antd'
import { connect } from 'react-redux'

import InputField from 'components/InputField'
import TextAreaField from 'components/TextArea'
import SelectField from 'components/SelectField'
import FileUpload from 'components/fileUpload'

import {
  SaveIco,
  SaveBlueIco,
  RefreshIco,
  SearchIco,
  MinusSmallIco,
  PlusSmallIco,
  EroorIco,
} from '../../../../../modules/CustomIcons'

import './index.scss'
import '../../transfer.scss'
import { OWNACCOUNT } from 'constants/constants'
import { SelectOptions } from '../../../../services/form'
import {
  Account,
  getAccounts,
  getSavedDocuments,
} from '../../../../services/account'
import { getCurrentCompany, getUserData } from '../../../../services/user'
import {
  checkAmountForRequest,
  fillCurrentForm,
  fillCurrentFormTemplate,
  financial,
  resetForm,
} from '../../../../services/helper'
import AmountField from 'components/AmountField'
import NextModal from 'components/NextModal'
import {
  getEdvDocumentNumber,
  getInAccountDocumentNumber,
} from '../../../../services/Accounts/DocumentNumber'
import { newTransfer } from '../../../../services/Transfers/InTransfer'
import TemplatePopup from 'components/TemplatePopup'
import { getCustomerCommission } from '../../../../services/Customers/Commission'
import {
  getAccountType,
  GetCustomerBenefAccountData,
  GetCustomerByIban,
  GetCustomerDataByIban,
} from '../../../../services/Transfers/GetCustomerByIban'
import SaveAsTemplate from 'components/SaveAsTemplate'
import { useLocation } from 'react-router-dom'
import FullScreenLoading from 'components/FullScreenLoading'
import { setIbanNumber } from '../../../../store/actions/accountStatement'
import { useActions } from 'hooks/useActions'
import { useTranslation } from 'react-i18next'
import { getMessageList } from '../../../../services/info'
import {deleteFileById} from "../../../../services/Transfers/Files";

const ibanDataReset = {
  iban: '',
  customerNo: '',
  customerName: '',
  customerStatus: '',
  customerTax: '',
  customerAddress: '',
  ccy: '',
  ccyType: '',
  brAccountType: '',
  showError: false,
}

const OtherAccount: React.FC<any> = ({ ownProps, ibanNumber }) => {
  const { t } = useTranslation()
  const [optionsDet, setOptionsDet] = useState<any[]>([])
  const modalDataInitial = {
    modalTitle: t('transfers.internalToOtherAccount'),
    groups: [
      {
        title: false,
        data: [],
      },
    ],
    pdfFiles: [],
    buttons: [
      { save: true },
      { sign: true },
      { approve: true },
      { send: true },
    ],
  }
  const [visible, setVisible] = useState(false)
  const [fromSelectOptions, setFromSelectOptions] = useState<SelectOptions[]>()
  const [nextModalVisible, setNextModalVisible] = useState(false)
  const [templatePopupVisible, setTemplatePopupVisible] = useState(false)
  const [saveAsTemplatePopupVisible, setSaveAsTemplatePopupVisible] =
    useState<boolean>(false)
  const [allAccounts, setAllAccounts] = useState<Account[]>()
  const [documentNumber2, setDocumentNumber2] = useState<string>('')
  const [fromBranch2, setFromBranch2] = useState<Account>()
  const [toSelectOptions, setToSelectOptions] = useState<SelectOptions[]>()
  const [calcEdv, setCalcEdv] = useState('')
  const [commissionLoading2, setCommissionLoading2] = useState(false)
  const [commissionAmount2, setCommissionAmount2] = useState('')
  const [fromBranch, setFromBranch] = useState<Account>()
  const [toBranch, setToBranch] = useState<Account>()
  const [modalData, setModalData] = useState(modalDataInitial)
  const [documentNumber, setDocumentNumber] = useState<string>('')
  const [commissionLoading, setCommissionLoading] = useState(false)
  const [commissionAmount, setCommissionAmount] = useState('')
  const [userByIbanData, setUserByIbanData] =
    useState<GetCustomerByIban>(ibanDataReset)
  const [loadingAccount, setLoadingAccount] = useState(false)
  const [ibanMessage, setIbanMessage] = useState<string>('')
  const [loadingData, setLoadingData] = useState(false)
  const [ibankRef, setIbankRef] = useState<string>('')
  const [pdfCount, setPdfCount] = useState(0)
  const [fileList, setFileList] = useState<any[]>([])
  const [tableData, setTableData] = useState<any[]>([])
  const [editOrRepeat, setEdit] = useState(false)
  const { setIbanNumber } = useActions()
  const [isTouched, setIsTouched] = useState(false)
  const [hasError, setHasError] = useState(false)
  const [maindetail, setMainDet] = useState<any>('')
  const [dropListLoading, setDropListLoading] = useState(false)
  const [showHideEdvBox, setShowHideEdvBox] = useState(false)
  const [tax_required, setTax_required] = useState(false)
  const [fileUp, setFileUp] = useState<any[]>([])
  const [form] = Form.useForm()
  const location = useLocation()
  const language = localStorage.getItem('i18nextLng')

  const addOrEditPage = ownProps?.addOrEditPage || false

  const updateParentComponentFormData = () => {
    if (ownProps?.getFormElements) {
      ownProps?.getFormElements({form})
    }
  }
  

  useEffect(() => {
    updateParentComponentFormData()
  }, [showHideEdvBox]);


  const fetchData = async () => {
    setLoadingAccount(true)
    const data = await getAccounts(getCurrentCompany())

    let temp_data = []

    for (let row of data) {
      if (row.STATUS !== '0') {
        // @ts-ignore
        temp_data.push({
          label: row.NICKNAME ? row.NICKNAME : row.IBAN,
          value: row.IBAN,
          extra: `${financial(row.BALANCE)} ${row.CCY_NAME}`,
        })
      }
    }

    setAllAccounts(data.filter((row) => row.STATUS !== '0'))
    setFromSelectOptions((old_data) => temp_data)

    /**/
    if (location?.state?.trnData) {
      fillCurrentForm(form, location.state.trnData)
    }
    setLoadingAccount(false)
  }

  const fetchDataDropList = async () => {
    setDropListLoading(true)
    const data = await getMessageList()
    let temp_data = []
    if (
      data.messageList !== undefined &&
      data.messageList !== null &&
      data.messageList.length > 0
    ) {
      for (let row of data.messageList) {
        if (row.messageKey.toString().includes('DROP.ALL')) {
          // @ts-ignore
          let labelText
          switch (language) {
            case 'az':
              labelText = row.textAZE
              break
            case 'ru':
              labelText = row.textRU
              break
            case 'en':
              labelText = row.textENG
              break
            default:
              labelText = row.textAZE
          }

          temp_data.push({
            label: labelText,
            value: labelText,
          })
        }
      }
    }
    setDropListLoading(false)
    console.log(temp_data)
    setOptionsDet((old_data) => temp_data)
  }

  useEffect(() => {
    fetchDataDropList()
    if (location.state?.data) loadData()
    else if (location.state?.trnData) loadDataTemplate2(location.state)
    else fetchData()
  }, [location.state])

  const loadData = async () => {
    setLoadingAccount(true)
    setLoadingData(true)
    const data = await getAccounts(getCurrentCompany())
    let temp_data = []
    for (let row of data) {
      if (row.STATUS !== '0') {
        // @ts-ignore
        temp_data.push({
          label: row.NICKNAME ? row.NICKNAME : row.IBAN,
          value: row.IBAN,
          extra: `${financial(row.BALANCE)} ${row.CCY_NAME}`,
        })
      }
    }
    if (location.state?.edit) {
      setEdit(true)
    } else {
      setEdit(false)
    }
    setAllAccounts(data.filter((row) => row.STATUS !== '0'))
    setFromSelectOptions((old_data) => temp_data)
    /**/
    // if (location?.state?.data) {
    //     fillCurrentForm(form, location.state.data)
    // }
    if (location.state?.edit) setIbankRef(location.state?.data['ibankRef'])
    setPdfCount(location.state?.data['attachedPDF'])
    setLoadingAccount(false)
    // CUSTACC
    const findAccount = data?.find(
      (row) => row.IBAN == location.state?.data['CUSTACC']
    )
    setFromBranch(findAccount)
    if (
      (form.getFieldValue('PMTCUSTID') === '' ||
        form.getFieldValue('PMTCUSTID') === undefined) &&
      location.state?.edit === undefined
    ) {
      updateDocumentNumber()
    } else if (location.state?.edit) {
      form.setFieldsValue({
        PMTCUSTID: location.state?.data['PMTCUSTID'],
      })
    }
    if (!form.getFieldValue('PMTCUSTID2') && location.state?.data['CUSTACC']) {
                    setFromBranch2(findAccount);
                }
    form.setFieldsValue({
      CUSTACC: location.state?.data['CUSTACC'],
    })
    form.setFieldsValue({
      COMMAMOUNT: '0.00',
    })
   
    let calc_percent=(value * 18 ) / 100;
    setCalcEdv(old_value => calc_percent);
    setCommissionAmount((old_value) => '0.00')
    // AMOUNT
    form.setFieldsValue({
      AMOUNT: checkAmountForRequest(location.state?.data['AMOUNT']),
    })
            setCalcEdv(old_value => '');
            
 let value = checkAmountForRequest(location.state?.data['AMOUNT']);
            setCalcEdv(old_value => '');

            // @ts-ignore
            if (!isNaN(value)) {
              setCommissionLoading(true);
              let calc_percent=(value * 18 ) / 100;
              setCalcEdv(old_value => calc_percent);
              
  
              form.setFieldsValue({
                COMMAMOUNT: '0.00',
              })
              setCommissionAmount((old_value) => '0.00')
              setCommissionLoading(false);


          }
            else {
                setCommissionLoading(false);
                form.setFieldsValue({
                    'COMMAMOUNT' : ''
                });
                setCommissionAmount(old_value => '');
            }
    form.setFieldsValue({
      NOTE: location.state?.data['NOTE'],
    })
    // BENEFACC
    form.setFieldsValue({
      BENEFACC: location.state?.data['BENEFACC'],
    })
    let getDataForPMTDET
    const findAccount1 = data?.find(
      (row) => row.IBAN == location.state?.data['BENEFACC']
    )
    if (findAccount1 === undefined) {
      let value = location.state?.data['BENEFACC']

      setUserByIbanData((old_data) => [])

      if (value.length > 0) {
        const req_data = {
          pmtTypeCode: 'INTERNAL',
          benefAcc:
            value !== undefined && value !== null
              ? value.toString().toUpperCase()
              : '',
          custAccCurr: location.state?.data['ccyType'],
        }
        const getData = await GetCustomerBenefAccountData(
          getCurrentCompany(),
          req_data
        )
        if (getData['IB4C_Check_BenefAcc_Resp']['msgStatus'] === 'FAILURE') {
          setUserByIbanData((old_data) => ({
            ...old_data,
            brAccountType: '',
            customerName: '',
            customerTax: '',
            showError: true,
          }))
          form.validateFields(['BENEFACC'])
          form.setFieldsValue({ BENEFNAME: '' })
          form.setFieldsValue({ BENEFACCTYPE: '' })
        } else {
          getDataForPMTDET =
            getData['IB4C_Check_BenefAcc_Resp']['benefAccClassCode']
          setUserByIbanData((old_data) => ({
            ...old_data,
            iban: value,
            customerTax: getData['IB4C_Check_BenefAcc_Resp']['benefTaxId'],
            brAccountType: getData['IB4C_Check_BenefAcc_Resp']['benefAccType'],
            customerName: getData['IB4C_Check_BenefAcc_Resp']['benefName'],
            acc_class: getData['IB4C_Check_BenefAcc_Resp']['benefAccClassCode'],
            showError: false,
          }))
        }
        setIbanMessage(getData['IB4C_Check_BenefAcc_Resp']['msgRemark'])
      } else {
        setUserByIbanData((old_data) => [])
        form.setFieldsValue({ BENEFNAME: '' })
        form.setFieldsValue({ BENEFACCTYPE: '' })
        setIbanMessage('')
      }
    }

    //MAINDET PMTDET

    if (
      location.state?.data['mainDetail'] !== undefined &&
      location.state?.data['mainDetail'] !== null &&
      location.state?.data['mainDetail'] !== ''
    ) {
      form.setFieldsValue({
        MAINDET: location.state?.data['mainDetail'],
      })
      setMainDet(location.state?.data['mainDetail'])
      if (
        location.state?.data['PMTDET']?.includes(
          location.state?.data['mainDetail']
        )
      ) {
        const PMTDETAILWithoutMainDet = location.state?.data['PMTDET']
          .replace(location.state?.data['mainDetail'], '')
          .trim()
        console.log('isledi 560')
        form.setFieldsValue({
          PMTDET:
            PMTDETAILWithoutMainDet.length > 105
              ? PMTDETAILWithoutMainDet.substring(0, 105)
              : PMTDETAILWithoutMainDet,
        })
      } else {
        console.log('isledi 566')
        form.setFieldsValue({
          PMTDET: location.state?.data['PMTDET'],
        })
      }
    } else {
      console.log(location.state?.data)
      if (
        getDataForPMTDET?.startsWith('4101') ||
        getDataForPMTDET?.startsWith('4102')
      ) {
        form.setFieldsValue({
          PMTDET:
            location.state?.data['PMTDET'].length > 105
              ? location.state?.data['PMTDET'].substring(0, 105)
              : location.state?.data['PMTDET'],
        })
      } else {
        form.setFieldsValue({
          PMTDET: location.state?.data['PMTDET'],
        })
      }

      form.setFieldsValue({
        MAINDET: undefined,
      })
      setMainDet('')
    }
    console.log(location.state?.data)
    if(location.state?.data['PMTAMOUNT2'] !== undefined && location.state?.data['PMTAMOUNT2'] !== "" && location.state?.data['PMTAMOUNT2'] !== null) {
                updateDocumentNumber2(false)
                let getValue = location.state?.data['PMTAMOUNT2'];
                let parsed_value = parseFloat(getValue?.toString().replace(/\s/g, ''));
                let value1 = parsed_value.toFixed(2);
                setShowHideEdvBox(old_value => true);
                form.setFieldsValue({
                    'PMTDET2': location.state?.data['PMTDET2']
                });
                const findAccount1 = data?.find(row => row.IBAN == location.state?.data['CUSTACC2'] && row.STATUS !== "0");
                if(findAccount1 !== undefined) {
                    setFromBranch2(findAccount1);
                }
    
                form.setFieldsValue({
                    'PMTAMOUNT2': location.state?.data['PMTAMOUNT2']
                });
                form.setFieldsValue({
                    'INFOTOBENEF2': location.state?.data['INFOTOBENEF2'].length >195 ? location.state?.data['INFOTOBENEF2'].substring(0,195) : location.state?.data['INFOTOBENEF2']
                });
    
                if (!isNaN(value1)) {
                    setCommissionLoading2(true);
                    setCalcEdv(old_value => value1);
                    getCustomerCommission({
                        PAYMENT_TYPE: "EDV",
                        CIF: getCurrentCompany().customerNo,
                        CUSTACC: findAccount?.IBAN,
                        AMOUNT: value1,
                        CUR: findAccount?.CCY_NAME,
                        BENEFBANKCODE: location.state?.data['BENEFBANKCODE'],
                        BENEFACC: location.state?.data['BENEFACC'],
                        BENEFTAXID: location.state?.data['BENEFTAXID'],
                        PMTDET: location.state?.data['PMTDET'],
                    }).then(res => {
                        setCommissionLoading2(false);
                        form.setFieldsValue({
                            'COMMAMOUNT2': res.COM_AMOUNT ?? ''
                        });
                        setCommissionAmount2(old_value => res.COM_AMOUNT ?? '')
                    })
                } else {
                    setCommissionLoading2(false);
                    form.setFieldsValue({
                        'COMMAMOUNT2': ''
                    });
                    setCalcEdv(old_value => '');
                    setCommissionAmount2(old_value => '');
                }
            }
    setLoadingData(false)
    const pdf = await getSavedDocuments(location.state?.data['ibankRef'])
    setFileList(pdf.data?.fileDetailsList)
    setTableData(location.state?.data)
  }

  const loadDataTemplate = async (tempData) => {
    setLoadingData(true)
    setShowHideEdvBox(false)
console.log('loaddata temp445')
    if (tempData?.trnData !== undefined) {
      const docid = documentNumber
      form.resetFields()
      if (tempData?.trnData) {
        fillCurrentFormTemplate(form, tempData?.trnData)
        updateParentComponentFormData()
      }
      if (docid !== '' && docid !== undefined) {
        form.setFieldsValue({
          PMTCUSTID: docid,
        })
        setDocumentNumber((old_value) => docid)
      }
      // CUSTACC
      const findAccount = allAccounts?.find(
        (row) => row.IBAN == tempData?.trnData.CUSTACC && row.STATUS !== '0'
      )
      if (findAccount !== undefined) {
        setFromBranch(findAccount)

        updateDocumentNumber()

        form.setFieldsValue({
          CUSTACC: tempData?.trnData.CUSTACC,
        })
      }
// AMOUNT
form.setFieldsValue({
  AMOUNT: tempData?.trnData.AMOUNT,
})
      
       let value = checkAmountForRequest(tempData?.trnData.AMOUNT);
              setCalcEdv(old_value => '');
      
              // @ts-ignore
              if (!isNaN(value)) {
                  setCommissionLoading(true);
                  let calc_percent=(value * 18 ) / 100;
                  setCalcEdv(old_value => calc_percent);
                  
      
                  form.setFieldsValue({
                    COMMAMOUNT: '0.00',
                  })
                  setCommissionAmount((old_value) => '0.00')
                  setCommissionLoading(false);


              }
              else {
                  setCommissionLoading(false);
                  form.setFieldsValue({
                      'COMMAMOUNT' : ''
                  });
                  setCommissionAmount(old_value => '');
              }
      // BENEFACC
      form.setFieldsValue({
        BENEFACC: tempData?.trnData.BENEFACC,
      })
      form.setFieldsValue({
        NOTE: tempData?.trnData.NOTE,
      })
      let getDataForPMTDET
      const findAccount1 = allAccounts?.find(
        (row) => row.IBAN == tempData?.trnData.BENEFACC
      )
      if (findAccount1 === undefined) {
        let value = tempData?.trnData.BENEFACC
        setUserByIbanData((old_data) => [])

        if (value.length > 0) {
          const req_data = {
            pmtTypeCode: 'INTERNAL',
            benefAcc:
              value !== undefined && value !== null
                ? value.toString().toUpperCase()
                : '',
            custAccCurr: findAccount?.CCY_NAME,
          }
          const getData = await GetCustomerBenefAccountData(
            getCurrentCompany(),
            req_data
          )
          if (getData['IB4C_Check_BenefAcc_Resp']['msgStatus'] === 'FAILURE') {
            setUserByIbanData((old_data) => ({
              ...old_data,
              brAccountType: '',
              customerName: '',
              customerTax: '',
              showError: true,
            }))
            form.validateFields(['BENEFACC'])
          } else {
            getDataForPMTDET =
              getData['IB4C_Check_BenefAcc_Resp']['benefAccClassCode']
            setUserByIbanData((old_data) => ({
              ...old_data,
              iban: value,
              customerTax: getData['IB4C_Check_BenefAcc_Resp']['benefTaxId'],
              brAccountType:
                getData['IB4C_Check_BenefAcc_Resp']['benefAccType'],
              customerName: getData['IB4C_Check_BenefAcc_Resp']['benefName'],
              acc_class:
                getData['IB4C_Check_BenefAcc_Resp']['benefAccClassCode'],
              showError: false,
            }))
          }
          setIbanMessage(getData['IB4C_Check_BenefAcc_Resp']['msgRemark'])
        } else {
          setUserByIbanData((old_data) => [])
          form.setFieldsValue({ BENEFNAME: '' })
          form.setFieldsValue({ BENEFACCTYPE: '' })
          setIbanMessage('')
        }
      }
      // PMTDET

      if (
        (tempData?.trnData.MAINDET !== undefined &&
          tempData?.trnData.MAINDET !== null) ||
        (tempData?.trnData.mainDetail !== undefined &&
          tempData?.trnData.mainDetail !== null &&
          tempData?.trnData.mainDetail !== '')
      ) {
        console.log(tempData?.trnData.PMTDET)
        form.setFieldsValue({
          MAINDET: tempData?.trnData.MAINDET || tempData?.trnData.mainDetail,
        })
        setMainDet(tempData?.trnData.MAINDET || tempData?.trnData.mainDetail)
        if (
          tempData?.trnData.PMTDET?.includes(
            tempData?.trnData.MAINDET || tempData?.trnData.mainDetail
          )
        ) {
          const PMTDETAILWithoutMainDet = tempData?.trnData.PMTDET.replace(
            tempData?.trnData.MAINDET || tempData?.trnData.mainDetail,
            ''
          ).trim()
          console.log('isledi 560')
          form.setFieldsValue({
            PMTDET:
              PMTDETAILWithoutMainDet.length > 105
                ? PMTDETAILWithoutMainDet.substring(0, 105)
                : PMTDETAILWithoutMainDet,
          })
        } else {
          console.log('isledi 566')
          form.setFieldsValue({
            PMTDET: tempData?.trnData?.PMTDET,
          })
        }
      } else {
        console.log('isledi 577')

        if (
          getDataForPMTDET?.startsWith('4101') ||
          getDataForPMTDET?.startsWith('4102')
        ) {
          form.setFieldsValue({
            PMTDET:
              tempData?.trnData.PMTDET.length > 105
                ? tempData?.trnData.PMTDET.substring(0, 105)
                : tempData?.trnData.PMTDET,
          })
        } else {
          form.setFieldsValue({
            PMTDET: tempData?.trnData.PMTDET,
          })
        }

        form.setFieldsValue({
          MAINDET: undefined,
        })
        setMainDet('')
      }
 if(tempData?.trnData.PMTAMOUNT2 !== undefined && tempData?.trnData.PMTAMOUNT2 !== "" && tempData?.trnData.PMTAMOUNT2 !== null) {
            await updateDocumentNumber2(false)
            let getValue = tempData?.trnData.PMTAMOUNT2;
            let parsed_value = parseFloat(getValue?.toString().replace(/\s/g, ''));
            let value1 = parsed_value.toFixed(2);
            setShowHideEdvBox(old_value => true);
            form.setFieldsValue({
                'PMTDET2': tempData?.trnData.PMTDET2
            });
            const findAccount1 = allAccounts?.find(row => row.IBAN == tempData?.trnData.CUSTACC2 && row.STATUS !== "0");
            if(findAccount1 !== undefined) {
                setFromBranch2(findAccount1);
            }

            form.setFieldsValue({
                'PMTAMOUNT2': tempData?.trnData.PMTAMOUNT2
            });
            if(tempData?.trnData.INFOTOBENEF2  !== undefined && tempData?.trnData.INFOTOBENEF2 !== null)
           {
             form.setFieldsValue({
                'INFOTOBENEF2': tempData?.trnData.INFOTOBENEF2.length >195 ? tempData?.trnData.INFOTOBENEF2.substring(0,195) : tempData?.trnData.INFOTOBENEF2
            });
        }

            if (!isNaN(value1)) {
                setCommissionLoading2(true);
                setCalcEdv(old_value => value1);
                const res = await getCustomerCommission({
                    PAYMENT_TYPE: "EDV",
                    CIF: getCurrentCompany().customerNo,
                    CUSTACC: findAccount?.IBAN,
                    AMOUNT: value1,
                    CUR: findAccount?.CCY_NAME,
                    BENEFBANKCODE: tempData?.trnData.BENEFBANKCODE,
                    BENEFACC: tempData?.trnData.BENEFACC,
                    BENEFTAXID: tempData?.trnData.BENEFTAXID,
                    PMTDET: tempData?.trnData.PMTDET,
                })

                if(res !== undefined) {
                    setCommissionLoading2(false);
                    form.setFieldsValue({
                        'COMMAMOUNT2': res.COM_AMOUNT ?? ''
                    });
                    setCommissionAmount2(old_value => res.COM_AMOUNT ?? '')
                }
            } else {
                setCommissionLoading2(false);
                form.setFieldsValue({
                    'COMMAMOUNT2': ''
                });
                setCalcEdv(old_value => '');
                setCommissionAmount2(old_value => '');
            }

        }
      // if(tempData?.trnData.MAINDET!==undefined || tempData?.trnData.MAINDET!==null){
      //     form.setFieldsValue({
      //                 'MAINDET': tempData?.trnData.MAINDET
      //             });
      //     setMainDet(tempData?.trnData.MAINDET)
      //         form.setFieldsValue({
      //             'PMTDET': tempData?.trnData.PMTDET
      //         });
      // }else{
      //     form.setFieldsValue({
      //         'PMTDET': tempData?.trnData.PMTDET
      //     });
      //     form.setFieldsValue({
      //         'MAINDET': undefined
      //     });
      //     setMainDet('')
      // }
    }
     
    setLoadingData(false)
  }

  const loadDataTemplate2 = async (tempData) => {
    console.log('loaddata2')
    setLoadingData(true)
    setLoadingAccount(true)
    const data = await getAccounts(getCurrentCompany())
    let temp_data = []
    for (let row of data) {
      if (row.STATUS !== '0') {
        // @ts-ignore
        temp_data.push({
          label: row.NICKNAME ? row.NICKNAME : row.IBAN,
          value: row.IBAN,
          extra: `${financial(row.BALANCE)} ${row.CCY_NAME}`,
        })
      }
    }
    setAllAccounts(data.filter((row) => row.STATUS !== '0'))
    setFromSelectOptions((old_data) => temp_data)
    /**/
    // if (tempData?.trnData) {
    //     fillCurrentForm(form, tempData?.trnData)
    //     updateParentComponentFormData();
    // }
    setLoadingAccount(false)
    // CUSTACC
    const findAccount = data?.find(
      (row) => row.IBAN == tempData?.trnData.CUSTACC && row.STATUS !== '0'
    )
    setFromBranch(findAccount)
    if (findAccount !== undefined) {
      await updateDocumentNumber()
    }
    form.setFieldsValue({
      CUSTACC: tempData?.trnData.CUSTACC,
    })
    form.setFieldsValue({
      COMMAMOUNT: '0.00',
    })
    setCommissionAmount((old_value) => '0.00')
    // AMOUNT
    form.setFieldsValue({
      AMOUNT: tempData?.trnData.AMOUNT,
    })
     let value = checkAmountForRequest(tempData?.trnData.AMOUNT);
            setCalcEdv(old_value => '');
    
            // @ts-ignore
            if (!isNaN(value)) {
              setCommissionLoading(true);
              let calc_percent=(value * 18 ) / 100;
              setCalcEdv(old_value => calc_percent);
              
  
              form.setFieldsValue({
                COMMAMOUNT: '0.00',
              })
              setCommissionAmount((old_value) => '0.00')
              setCommissionLoading(false);


          }
            else {
                setCommissionLoading(false);
                form.setFieldsValue({
                    'COMMAMOUNT' : ''
                });
                setCommissionAmount(old_value => '');
            }
    form.setFieldsValue({
      NOTE: tempData?.trnData.NOTE,
    })
    // BENEFACC
    form.setFieldsValue({
      BENEFACC: tempData?.trnData.BENEFACC,
    })
    let getDataForPMTDET
    const findAccount1 = data?.find(
      (row) => row.IBAN == tempData?.trnData.BENEFACC && row.STATUS !== '0'
    )
    if (findAccount1 === undefined) {
      let value = tempData?.trnData.BENEFACC
      setUserByIbanData((old_data) => [])

      if (value?.length > 0) {
        const req_data = {
          pmtTypeCode: 'INTERNAL',
          benefAcc:
            value !== undefined && value !== null
              ? value.toString().toUpperCase()
              : '',
          custAccCurr: findAccount?.CCY_NAME,
        }
        const getData = await GetCustomerBenefAccountData(
          getCurrentCompany(),
          req_data
        )
        if (getData['IB4C_Check_BenefAcc_Resp']['msgStatus'] === 'FAILURE') {
          setUserByIbanData((old_data) => ({
            ...old_data,
            brAccountType: '',
            customerName: '',
            customerTax: '',
            showError: true,
          }))
          form.validateFields(['BENEFACC'])
        } else {
          getDataForPMTDET =
            getData['IB4C_Check_BenefAcc_Resp']['benefAccClassCode']
          setUserByIbanData((old_data) => ({
            ...old_data,
            iban: value,
            customerTax: getData['IB4C_Check_BenefAcc_Resp']['benefTaxId'],
            brAccountType: getData['IB4C_Check_BenefAcc_Resp']['benefAccType'],
            customerName: getData['IB4C_Check_BenefAcc_Resp']['benefName'],
            acc_class: getData['IB4C_Check_BenefAcc_Resp']['benefAccClassCode'],
            showError: false,
          }))
        }
        setIbanMessage(getData['IB4C_Check_BenefAcc_Resp']['msgRemark'])
      } else {
        setUserByIbanData((old_data) => [])
        form.setFieldsValue({ BENEFNAME: '' })
        form.setFieldsValue({ BENEFACCTYPE: '' })
        setIbanMessage('')
      }
    }
    // PMTDET

    // const firstFindedMain=tempData?.trnData.PMTDET.substring(0, tempData?.trnData.PMTDET.indexOf(' '))
    // console.log(optionsDet.filter(row=>row.label.startsWith(firstFindedMain)))
    // const filteredOptions= optionsDet.filter(row=>row.label.startsWith(firstFindedMain))
    // if(filteredOptions.length===0 || firstFindedMain.length===0) {
    //     form.setFieldsValue({
    //         'PMTDET': tempData?.trnData.PMTDET
    //     });
    // }else{
    //     for(var item in filteredOptions){
    //         console.log(tempData?.trnData.PMTDET.contains(item))
    //     }
    // }
    if (
      (tempData?.trnData.MAINDET !== undefined &&
        tempData?.trnData.MAINDET !== null) ||
      (tempData?.trnData.mainDetail !== undefined &&
        tempData?.trnData.mainDetail !== null &&
        tempData?.trnData.mainDetail !== '')
    ) {
      console.log(tempData?.trnData.MAINDET)
      console.log(tempData?.trnData.PMTDET)
      form.setFieldsValue({
        MAINDET: tempData?.trnData.MAINDET || tempData?.trnData.mainDetail,
      })
      setMainDet(tempData?.trnData.MAINDET || tempData?.trnData.mainDetail)
      if (
        tempData?.trnData.PMTDET?.includes(
          tempData?.trnData.MAINDET || tempData?.trnData.mainDetail
        )
      ) {
        const PMTDETAILWithoutMainDet = tempData?.trnData.PMTDET.replace(
          tempData?.trnData.MAINDET || tempData?.trnData.mainDetail,
          ''
        ).trim()
        console.log('isledi 560')
        form.setFieldsValue({
          PMTDET:
            PMTDETAILWithoutMainDet.length > 105
              ? PMTDETAILWithoutMainDet.substring(0, 105)
              : PMTDETAILWithoutMainDet,
        })
      } else {
        console.log('isledi 566')
        form.setFieldsValue({
          PMTDET: tempData?.trnData?.PMTDET,
        })
      }
    } else {
      console.log('isledi 577')
      console.log(tempData?.trnData)
      console.log(getDataForPMTDET)
      if (
        getDataForPMTDET?.startsWith('4101') ||
        getDataForPMTDET?.startsWith('4102')
      ) {
        form.setFieldsValue({
          PMTDET:
            tempData?.trnData.PMTDET.length > 105
              ? tempData?.trnData.PMTDET.substring(0, 105)
              : tempData?.trnData.PMTDET,
        })
      } else {
        form.setFieldsValue({
          PMTDET: tempData?.trnData.PMTDET,
        })
      }

      form.setFieldsValue({
        MAINDET: undefined,
      })
      setMainDet('')
    }
if(tempData?.trnData.PMTAMOUNT2 !== undefined && tempData?.trnData.PMTAMOUNT2 !== "" && tempData?.trnData.PMTAMOUNT2 !== null) {
            updateDocumentNumber2(false)

            setShowHideEdvBox(old_value => true);
            let getValue = tempData?.trnData.PMTAMOUNT2;
            let parsed_value = parseFloat(getValue?.toString().replace(/\s/g, ''));
            let value1 = parsed_value.toFixed(2);

            form.setFieldsValue({
                'PMTDET2': tempData?.trnData.PMTDET2
            });

            const findAccount1 = data?.find(row => row.IBAN == tempData?.trnData.CUSTACC2 && row.STATUS !== "0");
            if(findAccount1 !== undefined) {
                setFromBranch2(findAccount1);
            }

            // form.setFieldsValue({
            //     'PMTCUSTID2': tempData?.trnData.PMTCUSTID2
            // });

            form.setFieldsValue({
                'PMTAMOUNT2': tempData?.trnData.PMTAMOUNT2
            });
            form.setFieldsValue({
                'INFOTOBENEF2': tempData?.trnData?.INFOTOBENEF2?.length >195 ? tempData?.trnData?.INFOTOBENEF2.substring(0,195) : tempData?.trnData?.INFOTOBENEF2
            });

            if (!isNaN(value1)) {
                setCommissionLoading2(true);
                setCalcEdv(old_value => value1);
                const res = await getCustomerCommission({
                    PAYMENT_TYPE: "EDV",
                    CIF: getCurrentCompany().customerNo,
                    CUSTACC: findAccount?.IBAN,
                    AMOUNT: value1,
                    CUR: findAccount?.CCY_NAME,
                    BENEFBANKCODE: tempData?.trnData.BENEFBANKCODE,
                    BENEFACC: tempData?.trnData.BENEFACC,
                    BENEFTAXID: tempData?.trnData.BENEFTAXID,
                    PMTDET: tempData?.trnData.PMTDET2,
                })
                if(res !== undefined) {
                    setCommissionLoading2(false);
                    form.setFieldsValue({
                        'COMMAMOUNT2': res.COM_AMOUNT ?? ''
                    });
                    setCommissionAmount2(old_value => res.COM_AMOUNT ?? '')
                }
            }
            else {
                setCommissionLoading2(false);
                form.setFieldsValue({
                    'COMMAMOUNT2': ''
                });
                setCalcEdv(old_value => '');
                setCommissionAmount2(old_value => '');
            }
            // setShowHideEdvBox(old_value => true);
        }
    updateParentComponentFormData()
    setLoadingData(false)
  }

  const updateDocumentNumber = async () => {
    const document_number = await getInAccountDocumentNumber(
      getCurrentCompany()
    )
    form.setFieldsValue({
      PMTCUSTID: document_number,
    })

    setDocumentNumber((old_value) => document_number)
  }

  const getSelectedFromBranch = (value: any) => {
    const findAccount = allAccounts?.find((row) => row.IBAN == value)
    setFromBranch(findAccount)
    // findUserByIban('');
    if (!form.getFieldValue('PMTCUSTID') && value) {
      updateDocumentNumber()
    }
    
    if (!form.getFieldValue('PMTCUSTID2') && value){
            getSelectedFromBranch2(value);
  }
    form.setFieldsValue({
      COMMAMOUNT: '0.00',
    })

    setCommissionAmount((old_value) => '0.00')
  }

  useEffect(() => {
    if (ibanNumber.iban && allAccounts) {
      const findAccount = allAccounts?.find(
        (row) => row.IBAN == ibanNumber.iban
      )
      setFromBranch(findAccount)
      // findUserByIban('');
      if (!form.getFieldValue('PMTCUSTID') && ibanNumber.iban) {
        updateDocumentNumber()
      }
      if (!form.getFieldValue('PMTCUSTID2') && ibanNumber.iban){
            getSelectedFromBranch2(ibanNumber.iban);
        }
      form.setFieldsValue({
        COMMAMOUNT: '0.00',
      })

      setCommissionAmount((old_value) => '0.00')

      setIbanNumber({ iban: undefined, ccy_name: undefined })
    }
  }, [ibanNumber, allAccounts])

  const getSelectedToBranch = (value: any) => {
    form.setFieldsValue({ BENEFNAME: '' })
    form.setFieldsValue({ BENEFACCTYPE: '' })
    if (value !== undefined && value?.target?.value?.length === 28)
      findUserByIban(value?.target?.value)
    else {
      setUserByIbanData((old_data) => [])
      setIbanMessage('')
    }
  }

  const getPastedToBranch = (value: any) => {
    form.setFieldsValue({ BENEFNAME: '' })
    form.setFieldsValue({ BENEFACCTYPE: '' })
    if (value !== undefined && value?.length === 28) findUserByIban(value)
    else {
      setUserByIbanData((old_data) => [])
      setIbanMessage('')
    }
  }

  const findUserByIban = async (e) => {
    let value = e.trim()

    setUserByIbanData((old_data) => [])

    if (value.length > 0) {
      const findAccount = allAccounts?.find((row) => row.IBAN == value)
      if (findAccount !== undefined) {
        setUserByIbanData((old_data) => [])
        form.setFieldsValue({ BENEFNAME: '' })
        form.setFieldsValue({ BENEFACCTYPE: '' })
        setUserByIbanData((old_data) => ({
          ...old_data,
          brAccountType: '',
          customerName: '',
          customerTax: '',
          acc_class: '',
          showError: true,
        }))
        setIbanMessage(t('newTransfer.enterValidAccount'))
      } else {
        const req_data = {
          pmtTypeCode: 'INTERNAL',
          benefAcc:
            value !== undefined && value !== null
              ? value.toString().toUpperCase()
              : '',
          custAccCurr: fromBranch?.CCY_NAME,
        }
        const getData = await GetCustomerBenefAccountData(
          getCurrentCompany(),
          req_data
        )
        if (getData['IB4C_Check_BenefAcc_Resp']['msgStatus'] === 'FAILURE') {
          setUserByIbanData((old_data) => ({
            ...old_data,
            brAccountType: '',
            customerName: '',
            customerTax: '',
            acc_class: '',
            showError: true,
          }))
          form.validateFields(['BENEFACC'])
        } else {
          setUserByIbanData((old_data) => ({
            ...old_data,
            iban: value,
            customerTax: getData['IB4C_Check_BenefAcc_Resp']['benefTaxId'],
            brAccountType: getData['IB4C_Check_BenefAcc_Resp']['benefAccType'],
            customerName: getData['IB4C_Check_BenefAcc_Resp']['benefName'],
            acc_class: getData['IB4C_Check_BenefAcc_Resp']['benefAccClassCode'],
            showError: false,
          }))
        }
        setIbanMessage(getData['IB4C_Check_BenefAcc_Resp']['msgRemark'])
      }
    } else {
      setUserByIbanData((old_data) => [])
      form.setFieldsValue({ BENEFNAME: '' })
      form.setFieldsValue({ BENEFACCTYPE: '' })
      setIbanMessage('')
    }
  }

  const updateToSelectOption = (findAccount) => {
    const data = allAccounts?.filter(
      (row) =>
        row.CCY_NAME == findAccount?.CCY_NAME && row.IBAN != findAccount?.IBAN
    )

    /*let temp_data=[];

        for (let row of data ){

            // @ts-ignore
            temp_data.push({
                label: row.IBAN,
                value: row.IBAN,
                extra: row.CCY_NAME
            });
        }

        setToSelectOptions(old_data => temp_data);*/
  }

useEffect(() => {
  setPdfCount(form.getFieldValue('pdf_files')?.length)
},[form.getFieldValue('pdf_files')])

  const newTransferFunc = async(RequestType: string) => {
    let pdf_files = form.getFieldValue('pdf_files') ?? []
    let detail =
      form.getFieldValue('PMTDET') !== undefined
        ? form.getFieldValue('PMTDET')
        : ''

     if(ibankRef !== "") {
            await   deleteFileById(ibankRef)
            await new Promise(res => setTimeout(res, 1000)); 
           }

    let amount2 =
      checkAmountForRequest(form.getFieldValue('PMTAMOUNT2')) ?? null

    let comission =
      checkAmountForRequest(form.getFieldValue('CUSTACCFORCOM')) ?? null

    return newTransfer({
      internal: {
        trnRequestType: RequestType,
        ccy: 1,
        ccyType: fromBranch?.CCY_NAME,
        PMTCUSTID: form.getFieldValue('PMTCUSTID'),
        CUSTACC: fromBranch?.IBAN,
        CUSTCIF: getCurrentCompany().customerNo,
        AMOUNT: checkAmountForRequest(form.getFieldValue('AMOUNT')),
        BENEFACC: userByIbanData.iban?.toUpperCase(),
        PMTDET:
          userByIbanData.acc_class?.startsWith('4101') ||
          userByIbanData.acc_class?.startsWith('4102')
            ? form.getFieldValue('MAINDET') + ' ' + detail
            : form.getFieldValue('PMTDET'),
        mainDetail: maindetail === '' ? null : maindetail,
        COMMAMOUNT: checkAmountForRequest(form.getFieldValue('COMMAMOUNT')),
        BENEFACCTYPE: form.getFieldValue('BENEFACCTYPE'),
        NOTE: form.getFieldValue('NOTE'),
        ibankRef: ibankRef,
        attachedPDF: pdfCount || pdf_files?.length,
        BENEFNAME: form.getFieldValue('BENEFNAME'),
      },
      edv: showHideEdvBox
        ? {
            trnRequestType: RequestType,
            PMTCUSTID: form.getFieldValue('PMTCUSTID2'),
            CUSTCIF: getCurrentCompany().customerNo,
            CUSTACC: fromBranch2?.IBAN,
            AMOUNT: amount2,
            BENEFNAME: form.getFieldValue('BENEFNAME').slice(0, 35),
            BENEFACC: form.getFieldValue('BENEFACC'),
            BENEFBANKCODE: toBranch?.CODE,
            BENEFBANKNAME: toBranch?.NAME,
            PMTDET: form.getFieldValue('PMTDET2'),
            BENEFTAXID: userByIbanData.customerTax,
            INFOTOBENEF: form.getFieldValue('INFOTOBENEF2'),
            NOTE: form.getFieldValue('NOTE'),
            CUSTACCFORCOM: fromBranch2?.IBAN,
            COMMAMOUNT:
              checkAmountForRequest(form.getFieldValue('COMMAMOUNT2')) ??
              comission,
          }
        : null,
    })
  }
  const resetFormFields = () => {
 
    setCalcEdv(old_value => '');
    setCommissionAmount2(old_value => '');
    setShowHideEdvBox(false);
    setNextModalVisible(false);
  
    // form.resetFields(['showHideEdvBox']);
}
  const onCloseSuccessModal = () => {
          resetForm(form);
          resetFormFields();
      }

  const submitHandler = async (args: any) => {
    let pdf_files = form.getFieldValue('pdf_files') ?? []
    modalDataInitial.pdfFiles = []

    if (pdf_files.length > 0) {
      for (let file of pdf_files) {
        modalDataInitial.pdfFiles.push({
          label: file.name,
          file: file,
        })
      }
    }
    let detail =
      form.getFieldValue('PMTDET') !== undefined
        ? form.getFieldValue('PMTDET')
        : ''

    let amount2 = financial(form.getFieldValue('PMTAMOUNT2'))
    let comission2 = financial(form.getFieldValue('COMMAMOUNT2'))
    let edv_data = showHideEdvBox
      ? {
          title: t('newTransfer.transfer18percVAT'),
          description: t('newTransfer.stateTreasuryAgency'),
          data: [
            {
              label: t('salary.documentNo'),
              value: args.PMTCUSTID2,
            },
            {
              label: t('transfers.fromAccount'),
              value: `${fromBranch2?.IBAN} ${fromBranch2?.CCY_NAME}`,
            },
            {
              label: t('common.amount'),
              value: `${amount2} ${fromBranch2?.CCY_NAME}`,
            },
            {
              label: t('home.commission'),
              value: `${comission2} ${fromBranch2?.CCY_NAME}`,
            },
            {
              label: t('accountStatement.paymentDetails'),
              value: args.PMTDET2 ?? '',
            },
            {
              label: t('transfers.infoForBeneficiary'),
              value: args.INFOTOBENEF2 ?? '',
            },
          ],
        }
      : null
    setModalData((old_data) => ({
      ...modalDataInitial,
      groups: [
        {
          title: false,
          data: [
            {
              label: t('transfers.sender'),
              value: getCurrentCompany().name,
            },
            {
              label: t('salary.documentNo'),
              value: `${args.PMTCUSTID}`,
            },
            {
              label: t('transfers.fromAccount'),
              value: `${fromBranch?.IBAN}`,
            },
            {
              label: t('common.amount'),
              value: `${financial(form.getFieldValue('AMOUNT'))} ${
                fromBranch?.CCY_NAME
              }`,
            },
            {
              label: t('transfers.accountNumber'),
              value: args.BENEFACC?.toUpperCase(),
            },
            {
              label: t('salary.accountHolder'),
              value: args.BENEFNAME,
            },
            {
              label: t('home.commission'),
              value: `${financial(args.COMMAMOUNT)} ${fromBranch?.CCY_NAME}`,
            },
            {
              label: t('accountStatement.paymentDetails'),
              value:
                userByIbanData.acc_class?.startsWith('4101') ||
                userByIbanData.acc_class?.startsWith('4102')
                  ? form.getFieldValue('MAINDET') + ' ' + detail
                  : form.getFieldValue('PMTDET'),
            },
            args.NOTE !== undefined
              ? {
                  label: t('newTransfer.note'),
                  value: args.NOTE ?? '',
                }
              : undefined,
          ],
        },
      ],
      edvInfoData: edv_data

    }))
    setNextModalVisible((old_value) => true)
  }

  const calculateCommission = (e) => {
    console.log(e)
    let value
        if(e.target !== undefined ){
            value=checkAmountForRequest(e.target.value);
        }else{
            value=checkAmountForRequest(e);
        }
    setCalcEdv(old_value => '');
console.log(value)
    if (!isNaN(value)) {
      let calc_percent = (value * 18) / 100

      setCalcEdv((old_value) => calc_percent)
      console.log(calc_percent)
      form.setFieldsValue({
        PMTAMOUNT2: calc_percent,
      })
      //   setCommissionLoading(true)
      if (showHideEdvBox) calculateCommission2(calc_percent)
      //   getCustomerCommission({
      //       PAYMENT_TYPE : "EDV",
      //       CIF : getCurrentCompany().customerNo,
      //       CUSTACC : fromBranch?.IBAN,
      //       AMOUNT : value,
      //       CUR : fromBranch?.CCY_NAME,
      //       BENEFBANKCODE : form.getFieldValue('BENEFBANKCODE'),
      //       BENEFACC : form.getFieldValue('BENEFACC')?.toUpperCase(),
      //       BENEFTAXID : form.getFieldValue('BENEFTAXID'),
      //       PMTDET : form.getFieldValue('PMTDET'),
      //   }).then(res => {
      //       setCommissionLoading(false);
      //       setCommissionAmount(old_value =>  res.COM_AMOUNT ?? '')
      //       form.setFieldsValue({
      //           'COMMAMOUNT' : res.COM_AMOUNT ?? ''
      //       });
      //   })
      //   getCustomerCommission({
      //     PAYMENT_TYPE: 'INTERNAL',
      //     CIF: getCurrentCompany().customerNo,
      //     CUSTACC: fromBranch?.IBAN,
      //     AMOUNT: value,
      //     CUR: fromBranch?.CCY_NAME,
      //     BENEFBANKCODE: form.getFieldValue('BENEFBANKCODE'),
      //     BENEFACC: form.getFieldValue('BENEFACC')?.toUpperCase(),
      //     BENEFTAXID: userByIbanData.customerTax,
      //     PMTDET: form.getFieldValue('PMTDET'),
      //   }).then((res) => {
      //     setCommissionLoading(false)

      //     form.setFieldsValue({
      //       COMMAMOUNT: res.COM_AMOUNT ?? '',
      //     })

      //     setCommissionAmount((old_value) => res.COM_AMOUNT ?? '')
      //   })
    } else {
      setCommissionLoading(false)
      form.setFieldsValue({
        COMMAMOUNT: '0.00',
      })
      setCommissionAmount((old_value) => '0.00')
    }
  }

  const getFileList = (info: any) => {
    form.setFieldsValue({
      pdf_files: info.fileList,
    })
  }

  const openSaveAsTemplateModal = () => {
    setSaveAsTemplatePopupVisible((old_data) => false)

    form
      .validateFields()
      .then((res) => {
        setSaveAsTemplatePopupVisible((old_data) => true)
      })
      .catch((err_input_list) => {})
  }

  const updateDocumentNumberAndCommission = (data) => {
    loadDataTemplate(data)
  }

  
  const removeFile = (index: any) => {
    const myNewFiles = [...fileList]
    myNewFiles.splice(index, 1)
    setFileList(myNewFiles)
  }
  const handleMainDet = (value: any) => {
    setMainDet(value)
    setIsTouched(true)
    setHasError(value === null || value === undefined)
  }
  
      const calculateCommission2 =async (e) => {
          let getValue=e?.target?.value ? e.target.value : e;
          let parsed_value=parseFloat(getValue?.toString().replace(/\s/g, ''));
          let value=parsed_value.toFixed(2);
  
  
  
          if (!isNaN(value)){
              let amount_value=parseFloat(form.getFieldValue('AMOUNT')?.toString().replace(/\s/g, ''));
              let calc_percent=(amount_value * 18 ) / 100;
  
              //if (parsed_value <= calc_percent){
                  setCommissionLoading2(true);
  
                  setCalcEdv(old_value => value);
                  form.setFieldsValue({
                      'PMTAMOUNT2' : value
                  });
                 await getCustomerCommission({
                      PAYMENT_TYPE : "EDV",
                      CIF : getCurrentCompany().customerNo,
                      CUSTACC : fromBranch?.IBAN,
                      AMOUNT : value,
                      CUR : fromBranch?.CCY_NAME,
                      BENEFBANKCODE : form.getFieldValue('BENEFBANKCODE'),
                      BENEFACC : form.getFieldValue('BENEFACC')?.toUpperCase(),
                      BENEFTAXID : form.getFieldValue('BENEFTAXID'),
                      PMTDET : form.getFieldValue('PMTDET'),
                  }).then(res => {
                      setCommissionLoading2(false);
                      form.setFieldsValue({
                          'COMMAMOUNT2' : res.COM_AMOUNT ?? ''
                      });
  
                      setCommissionAmount2(old_value => res.COM_AMOUNT ?? '')
  
                  })
              /*}else{
                  form.setFieldsValue({
                      'COMMAMOUNT2' : ''
                  });
                  setCommissionAmount2(old_value => '');
  
  
  
              }*/
          }else{
              setCommissionLoading2(false);
  
              form.setFieldsValue({
                  'COMMAMOUNT2' : ''
              });
              setCalcEdv(old_value => '');
              setCommissionAmount2(old_value => '');
          }
          updateParentComponentFormData()
      }
  const updateDocumentNumber2 = async (setDetail: boolean) => {
    console.log(setDetail)
    const document_number = await getEdvDocumentNumber(getCurrentCompany())
    form.setFieldsValue({
      "PMTCUSTID2": document_number,
    })
    if (setDetail) {
      form.setFieldsValue({
        PMTDET2: form.getFieldValue('PMTDET'),
      })
    }
    updateParentComponentFormData()
    setDocumentNumber2((old_value) => document_number)
  }

  const getSelectedFromBranch2 = (value: any) => {
    const findAccount = allAccounts?.find((row) => row.IBAN == value)
    setFromBranch2(findAccount)
  }
  const onchangeEdv = async () => {
    console.log(calcEdv)
    if (!showHideEdvBox) {
      updateDocumentNumber2(true)
      calculateCommission2(calcEdv)
      getSelectedFromBranch2(fromBranch?.IBAN)
      // updateParentComponentFormData()
    } else {
      form.setFieldsValue({
        PMTCUSTID2: null,
      })
      setDocumentNumber2((old_value) => null)
      form.setFieldsValue({
        COMMAMOUNT2: null,
      })
      form.setFieldsValue({
        PMTAMOUNT2: null,
      })
      form.setFieldsValue({
        PMTDET2: null,
      })
      form.setFieldsValue({
        INFOTOBENEF2: null,
      })
      // updateParentComponentFormData()
    }
    setShowHideEdvBox((old_value) => !showHideEdvBox)
    setTax_required(!tax_required)
  }
  return (
    <>
      <Row>
        <Col flex={'700px'} className="own-account">
          <Card bordered={false}>
            <Row justify="start" className="own-account__form">
              <Form
                labelCol={{ flex: '190px' }}
                wrapperCol={{ flex: 1 }}
                className="full"
                onSubmit={(e) => e.preventDefault(e)}
                onFinish={submitHandler}
                id={'form'}
                form={form}
                autoComplete="off"
                onValuesChange={updateParentComponentFormData}
                scrollToFirstError={{
                  behavior: 'smooth',
                  block: 'center',
                  inline: 'center',
                }}
              >
                {!addOrEditPage && (
                  <div className="flex ">
                    <InputField
                      labelItem={t('salary.documentNo')}
                      placeholder={t('salary.automatically')}
                      name={'PMTCUSTID'}
                      required={true}
                      form={form}
                      value={documentNumber}
                      message={true}
                      maxLength={25}
                      allowLatinNumber={true}
                    />

                    <Button
                      size={'large'}
                      icon={<SaveIco />}
                      className="blue-button transfer__button flex align_center justify_center create_tr_template_btn"
                      onClick={(e) => setTemplatePopupVisible(true)}
                    >
                      {OWNACCOUNT.PATTERN}
                    </Button>
                  </div>
                )}

                <SelectField
                  labelItem={t('transfers.fromAccount')}
                  placeholder={t('accountStatement.chooseAccount')}
                  options={fromSelectOptions}
                  name={'CUSTACC'}
                  onChange={getSelectedFromBranch}
                  required={true}
                  form={form}
                  account={true}
                  notFoundContent={
                    !loadingAccount
                      ? t('newTransfer.noAccountCorrespondingCurrency')
                      : undefined
                  }
                  defaultValue={ibanNumber.iban}
                />

                <div className={'flex justify_between'}>
                  <AmountField
                    labelItem={t('common.amount')}
                    placeholder=""
                    suffix={fromBranch?.CCY_NAME}
                    name={'AMOUNT'}
                    form={form}
                    className={`no_flex commission_left amount_input isDisabled`}
                    required={true}
                    disabled={!fromBranch?.ACCOUNT_NO}
                    onBlur={calculateCommission}
                    
                  />

                  <InputField
                    labelItem={t('home.commission')}
                    placeholder=""
                    className=" commission_right commission_input commission_border isReadOnly"
                    readOnly={true}
                    suffix={fromBranch?.CCY_NAME}
                    value={''}
                    name={'COMMAMOUNT'}
                    form={form}
                    staticValue={true}
                    hasLoading={commissionLoading}
                    required={true}
                    message={''}
                    notValid={commissionAmount === ''}
                  />
                </div>
                <InputField
                  labelItem={t('deposit.accountNumber')}
                  placeholder=""
                  name={'BENEFACC'}
                  required={true}
                  form={form}
                  allowLatin={true}
                  maxLength={28}
                  disabled={!fromBranch?.ACCOUNT_NO}
                  onChange={getSelectedToBranch}
                  onPaste={getPastedToBranch}
                  className={'is_upper_case isDisabled'}
                  message={ibanMessage}
                  notValid={
                    userByIbanData.showError &&
                    userByIbanData.customerName === ''
                  }
                  upper={true}
                  account={true}
                />

                <InputField
                  labelItem={t('newTransfer.accountType')}
                  placeholder=""
                  required={true}
                  readOnly={true}
                  className={'not_show_required_props isReadOnly'}
                  name={'BENEFACCTYPE'}
                  form={form}
                  value={getAccountType(userByIbanData?.brAccountType)}
                />

                <InputField
                  labelItem={t('salary.accountHolder')}
                  placeholder=""
                  readOnly={true}
                  name={'BENEFNAME'}
                  className={'isReadOnly'}
                  allowLatin={true}
                  form={form}
                  value={userByIbanData?.customerName}
                />
                {userByIbanData.acc_class?.startsWith('4101') ||
                userByIbanData.acc_class?.startsWith('4102') ? (
                  <div>
                    {' '}
                    <Form.Item
                      label={t('accountStatement.mainPayment')}
                      name={'MAINDET'}
                      form={form}
                      rules={[
                        {
                          required: true,
                          message: t('newTransfer.requiredField'),
                        },
                      ]}
                      validateTrigger="onBlur"
                    >
                      <Select
                        status={hasError && isTouched ? 'error' : ''}
                        style={{
                          width: '100%',
                        }}
                        onChange={(value: string) => handleMainDet(value)}
                        size="large"
                        value={maindetail}
                        // notValid={maindetail===null?'error':''}
                        // required={true}
                        placeholder={t('transfers.select')}
                        disabled={!fromBranch}
                        options={optionsDet}
                        notFoundContent={dropListLoading}
                      />
                    </Form.Item>
                    <TextAreaField
                      visible={true}
                      labelItem={t('accountStatement.additionalPaymentDetails')}
                      placeholder=""
                      showCount={true}
                      maxLength={'105'}
                      name={'PMTDET'}
                      required={false}
                      message={t('newTransfer.requiredField')}
                      form={form}
                      allowLatin={true}
                      readOnly={!fromBranch?.ACCOUNT_NO}
                      className={'isReadOnly'}
                    />
                  </div>
                ) : (
                  <TextAreaField
                    visible={true}
                    labelItem={t('accountStatement.paymentDetails')}
                    placeholder=""
                    showCount={true}
                    maxLength={'140'}
                    name={'PMTDET'}
                    required={true}
                    form={form}
                    // allowDestination={true}
                    allowLatin={true}
                    disabled={!fromBranch?.ACCOUNT_NO}
                    className={'isDisabled'}
                  />
                )}

                <div className={'flex edv_checkbox'}>
                  <Col flex={'190px'}>&nbsp;</Col>
                  <Checkbox
                    disabled={!fromBranch?.ACCOUNT_NO || (userByIbanData.acc_class?.startsWith('4101') ||
                userByIbanData.acc_class?.startsWith('4102'))}
                    onChange={(e) => {
                      onchangeEdv()
                    }}
                    checked={showHideEdvBox}
                  >
                    {t('newTransfer.create18percVATtransfer')}
                  </Checkbox>
                </div>
                {showHideEdvBox && (
                  <div className="box_row_edv">
                    {!addOrEditPage && (
                      <InputField
                        labelItem={t('salary.documentNo')}
                        placeholder={t('salary.automatically')}
                        name={'PMTCUSTID2'}
                        required={true}
                        form={form}
                        value={documentNumber2}
                        message={true}
                        maxLength={25}
                        allowLatinNumber={true}
                      />
                    )}

                    <SelectField
                      labelItem={t('transfers.fromAccount')}
                      placeholder={t('accountStatement.chooseAccount')}
                      options={toSelectOptions}
                      name={'CUSTACC2'}
                      required={true}
                      form={form}
                      onChange={getSelectedFromBranch2}
                      value={fromBranch?.IBAN}
                    />

                    <div className={'flex'}>
                      <AmountField
                        labelItem={t('common.amount')}
                        placeholder=""
                        suffix={fromBranch?.CCY_NAME}
                        name={'PMTAMOUNT2'}
                        className={'amount_and_commission_col amount_input'}
                        required={true}
                        form={form}
                        value={calcEdv}
                        onBlur={calculateCommission2}
                      />

                      <Col className={'commission_col mobile-select'}>
                        <InputField
                          labelCol={2}
                          labelItem={t('home.commission')}
                          placeholder=""
                          className="dark-input commission_input isReadOnly commission_border"
                          readOnly={true}
                          suffix={fromBranch?.CCY_NAME}
                          name={'COMMAMOUNT2'}
                          value={commissionAmount2}
                          hasLoading={commissionLoading2}
                          form={form}
                          required={showHideEdvBox}
                          message={''}
                          notValid={form.getFieldValue('COMMAMOUNT2') == ''}
                        />
                      </Col>
                    </div>

                    <TextAreaField
                      visible={true}
                      labelItem={t('accountStatement.paymentDetails')}
                      placeholder=""
                      showCount={true}
                      maxLength={'140'}
                      name={'PMTDET2'}
                      required={true}
                      form={form}
                      allowLatin={true}
                    />

                    <TextAreaField
                      visible={true}
                      labelItem={t('transfers.infoForBeneficiary')}
                      placeholder=""
                      showCount={true}
                      maxLength={'195'}
                      className={'no_required'}
                      form={form}
                      name={'INFOTOBENEF2'}
                      allowLatin={true}
                    />

                    <div className={'flex'}>
                      <Col flex={'170px'}>&nbsp;</Col>
                      <span>{t('newTransfer.stateTreasuryAgency')}</span>
                    </div>
                  </div>
                )}
                <div className={'flex'}>
                  <Col flex={1}>
                    <TextAreaField
                      visible={visible}
                      // className='not-required plus_minus_area isReadOnly'
                      labelItem={t('newTransfer.note')}
                      placeholder={t('newTransfer.notTransferableToBank')}
                      showCount={true}
                      maxLength={'180'}
                      name={'NOTE'}
                      form={form}
                      disabled={
                        !fromBranch?.ACCOUNT_NO && !toBranch?.PRODUCT_NAME
                      }
                      // allowAllSymboll={true}
                      allowLatin={true}
                      className={'isDisabled'}
                    />
                  </Col>
                  <Button
                    className="icon-button add-remove-btn"
                    icon={visible ? <MinusSmallIco /> : <PlusSmallIco />}
                    onClick={() => setVisible(!visible)}
                  />
                </div>

                <FileUpload
                  className="file-upload isDisabled"
                  labelItem={t('newTransfer.attachPDF')}
                  accept="application/pdf"
                  multiple={false}
                  required={false}
                  disabled={!fromBranch?.ACCOUNT_NO}
                  form={form}
                  name={'pdf_files'}
                  fileLimit={10}
                  editOrRepeat={editOrRepeat}
                  checkSize={true}
                  onChange={getFileList}
                  editFileList={fileList}
                  tempFileList={fileUp}
                  ibankRef={ibankRef}
                  removeFile={removeFile}
                />

                {!addOrEditPage && (
                  <div className="flex button_row">
                    <Button
                      size={'large'}
                      icon={<SaveBlueIco />}
                      className="light-button btn save_btn flex align_center justify_center"
                      htmlType={'button'}
                      onClick={openSaveAsTemplateModal}
                    >
                      {OWNACCOUNT.SAVE}
                    </Button>

                    <div className={'flex flex_wrap'}>
                      <Button
                        size={'large'}
                        icon={<RefreshIco />}
                        className="light-button refresh_btn btn flex align_center justify_center"
                        onClick={(e) => {
                          resetForm(form)
                          resetFormFields()
                          setIbanMessage('')
                        }}
                      >
                        {t(OWNACCOUNT.REFRESH)}
                      </Button>

                      <Button
                        size={'large'}
                        htmlType="submit"
                        className="blue-button next_btn btn flex align_center justify_center"
                        // disabled={!userByIbanData?.customerName}
                      >
                        {OWNACCOUNT.NEXT}
                      </Button>
                    </div>
                  </div>
                )}
              </Form>
            </Row>
          </Card>
        </Col>
      </Row>

      <NextModal
        errorIcon={<EroorIco />}
        callBackApi={newTransferFunc}
        visible={nextModalVisible}
        onClose={setNextModalVisible}
        onCloseSuccessModal={() => { onCloseSuccessModal() }}

        data={modalData}
        className={'transfer_other_account'}
        nextModalTitle={t('home.transfer')}
        nextModalText={`Əməliyyat uğurla saxlanılmış, imzalanmışdır və banka göndərilməsini gözləməkdədir.`}
        currentForm={form}
        repeatPdfList={fileList}
        transfer={true}
        tableData={tableData}
        editTransfer={
          ibankRef !== undefined && ibankRef !== '' && ibankRef !== null
        }
      />

      <TemplatePopup
        visible={templatePopupVisible}
        onClose={setTemplatePopupVisible}
        trnType={'INTERNAL'}
        currentForm={form}
        // setFileList = {setFileUp}
        updateAfterTemplate={updateDocumentNumberAndCommission}
      />

      <SaveAsTemplate
        visible={saveAsTemplatePopupVisible}
        onClose={setSaveAsTemplatePopupVisible}
        trnType={'INTERNAL'}
        currentForm={form}
      />

      {loadingData ? <FullScreenLoading /> : <></>}
    </>
  )
}

const mapDispatchToProps = { setIbanNumber }

const mapStateToProps = (state: any, ownProps: any) => ({
  ownProps: ownProps,
  ibanNumber:
    state.accountsStatement && state.accountsStatement.ibanNumber
      ? state.accountsStatement.ibanNumber
      : {},
})

export default connect(mapStateToProps, mapDispatchToProps)(OtherAccount)
